import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AppContext';
import API from '../utils/api';

export default function MyOrders() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    API.get('/orders/my')
      .then((r) => setOrders(r.data || []))
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, [user, navigate]);

  return (
    <div className="page-enter" style={{ maxWidth: 950, margin: '0 auto', padding: '48px 24px' }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 40, fontWeight: 300, marginBottom: 32 }}>
        My Orders
      </h1>

      {loading ? (
        <div className="spinner" />
      ) : orders.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📦</div>
          <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, marginBottom: 12 }}>
            No orders yet
          </h3>
          <button className="btn btn-primary" onClick={() => navigate('/collections')}>
            Start Shopping
          </button>
        </div>
      ) : (
        orders.map((o) => (
          <div
            key={o._id}
            style={{
              background: 'white',
              border: '1px solid var(--border)',
              borderRadius: 8,
              padding: 20,
              marginBottom: 18,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
              <div>
                <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, marginBottom: 4 }}>
                  Order #{o.orderId}
                </div>
                <div style={{ fontSize: 12, color: 'var(--text-light)' }}>
                  {new Date(o.createdAt).toLocaleDateString('en-IN', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: 'var(--maroon)', fontWeight: 600 }}>
                  ₹{o.totalAmount?.toLocaleString()}
                </span>

                <span
                  className={`tag ${o.orderStatus === 'delivered' ? 'stock-in-stock' : 'stock-low'}`}
                  style={{ textTransform: 'capitalize' }}
                >
                  {String(o.orderStatus || '').replaceAll('_', ' ')}
                </span>
              </div>
            </div>

            <div style={{ marginTop: 18, borderTop: '1px solid var(--border)', paddingTop: 16 }}>
              <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, marginBottom: 14 }}>
                Products Ordered
              </h4>

              {(o.items || []).map((item, index) => (
               <div
  key={index}
  onClick={() => {
    const productId = item.product?._id || item.product;
    if (productId) navigate(`/product/${productId}`);
  }}
  style={{
    display: 'grid',
    gridTemplateColumns: '70px 1fr auto',
    cursor: 'pointer',
  }}
                >
                  <img
                    src={item.image || item.product?.images?.[0]?.url || ''}
                    alt={item.name}
                    style={{
                      width: 70,
                      height: 70,
                      objectFit: 'cover',
                      borderRadius: 8,
                      background: 'var(--cream)',
                      border: '1px solid var(--border)',
                    }}
                  />

                  <div>
                    <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-dark)' }}>
                      {item.name || item.product?.name}
                    </div>
                    <div style={{ fontSize: 13, color: 'var(--text-light)', marginTop: 4 }}>
                      Qty: {item.qty} × ₹{Number(item.price || 0).toLocaleString()}
                    </div>
                    {item.category && (
                      <div style={{ fontSize: 12, color: 'var(--text-light)', marginTop: 3, textTransform: 'capitalize' }}>
                        {String(item.category).replaceAll('-', ' ')}
                      </div>
                    )}
                  </div>

                  <div style={{ fontWeight: 600, color: 'var(--maroon)', fontSize: 15 }}>
                    ₹{Number((item.price || 0) * (item.qty || 1)).toLocaleString()}
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, fontSize: 14 }}>
              <span style={{ color: 'var(--text-light)' }}>
                Payment: <b style={{ color: 'var(--text-dark)', textTransform: 'capitalize' }}>{o.paymentStatus || 'pending'}</b>
              </span>
              <span style={{ color: 'var(--text-light)' }}>
                Shipping: <b style={{ color: 'var(--text-dark)' }}>₹{Number(o.shippingCharge || 0).toLocaleString()}</b>
              </span>
            </div>
          </div>
        ))
      )}

      <style>{`
        @media(max-width: 600px) {
          .page-enter {
            padding: 32px 14px !important;
          }
        }
      `}</style>
    </div>
  );
}